import { useRef } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { validateUrl } from './util'
import {
  Actions,
  CancelBtn,
  CloseBtn,
  InputBox,
  InputFieldModal,
  Modal,
  ModalContentWrapper,
  ModalContent,
  ModalHeader,
  ModalLabel,
  StyledPopup,
  SubmitBtnModal,
} from './CommonStylesForms'

const StyledInputFieldModal = styled(InputFieldModal)`
  width: 100%;
`

function FormSchemaIssuanceAdd(props) {
  const dispatch = useDispatch()
  const schemaForm = useRef()
  const submitBtn = useRef()

  const webhookTargetUrls = props.webhookTargetUrls

  // Disable button on submit
  const onBtnClick = (e) => {
    if (submitBtn.current) {
      submitBtn.current.setAttribute('disabled', 'disabled')
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    onBtnClick()

    const form = new FormData(schemaForm.current)
    const url = form.get('url')

    if (!validateUrl(url)) {
      dispatch(
        props.setNotificationState({
          message: 'URL should be a valid URL format.',
          type: 'error',
        })
      )
      return
    }

    const index = webhookTargetUrls.indexOf(props.url)
    if (index !== -1) {
      const updatedUrlList = [...webhookTargetUrls]
      updatedUrlList.splice(index, 1, url)
      props.sendRequest('SETTINGS', 'SET_WEBHOOK_TARGET_URLS', {
        key: 'webhookTargetUrls',
        value: updatedUrlList,
      })
    }
    closeModal()
  }

  function closeModal() {
    props.closeEditModal()
  }

  return (
    <StyledPopup
      open={props.editWebhookUrlModalIsOpen}
      closeOnDocumentClick
      onClose={closeModal}
    >
      <Modal className="modal">
        <ModalHeader>Edit Webhook URL</ModalHeader>
        <ModalContentWrapper>
          <ModalContent>
            <form id="form" onSubmit={handleSubmit} ref={schemaForm}>
              <InputBox>
                <ModalLabel htmlFor="url">URL</ModalLabel>
                <StyledInputFieldModal
                  type="text"
                  name="url"
                  id="url"
                  defaultValue={props.url}
                  placeholder="https://example.com/webhook"
                  required
                />
              </InputBox>
              <Actions>
                <CancelBtn
                  type="button"
                  onClick={closeModal}
                  id="button-cancel"
                >
                  Cancel
                </CancelBtn>
                <SubmitBtnModal
                  type="submit"
                  ref={submitBtn}
                  id="button-submit"
                >
                  Submit
                </SubmitBtnModal>
              </Actions>
            </form>
          </ModalContent>
        </ModalContentWrapper>
        <CloseBtn onClick={closeModal} id="button-exit">
          &times;
        </CloseBtn>
      </Modal>
    </StyledPopup>
  )
}

export default FormSchemaIssuanceAdd
